import { accountConfig } from "@account/configs";
import { evaluateConfig } from "@crystal/core";
import { createGlassHttp } from "@crystal/glass-bridge";
import { ApiError } from "@crystal/http";
import { getToken } from "@crystal/recaptcha";
import { getExternalInvitationCode, getExternalTouchpointParameters, getExternalSourceId } from "../config/external-parameters.js";
import "../config/presets.js";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import "./email-detection.js";
import { FrontendName } from "../monitoring.js";
import { RegistrationError } from "./registration-types.js";
import "../ap2/config.js";
import "../ap2/state.js";
import "@crystal/analytics";
import "../external-auth/config.js";
import "@crystal/config";
import "../config/source-ids.js";
async function registerUser(payload) {
  const { post } = createGlassHttp({
    clientTag: FrontendName
  });
  const { recaptchaSiteKey } = evaluateConfig(accountConfig);
  try {
    const body = {
      ageConfirmation: true,
      ...payload,
      ...getExternalInvitationCode(),
      ...getExternalTouchpointParameters(),
      ...getExternalSourceId(),
      recaptcha: await getToken(recaptchaSiteKey, {
        action: "signup"
      })
    };
    return await post("/api/account", body);
  } catch (err) {
    let validationErrors;
    if (err instanceof ApiError) {
      validationErrors = getValidationErrors(err);
    }
    const error = new RegistrationError(err, {
      validationErrors,
      details: err
    });
    return Promise.reject(error.serialize());
  }
}
async function registerLightUser(data) {
  const { recaptchaSiteKey } = evaluateConfig(accountConfig);
  const body = {
    ...data,
    ...getExternalInvitationCode(),
    ...getExternalSourceId(),
    recaptcha: await getToken(recaptchaSiteKey, {
      action: "signup"
    })
  };
  const postWithAkamaiChallenge = async (url, body2) => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Client-Tag": "AccountPortal"
      },
      body: JSON.stringify(body2)
    });
    if (response.ok) {
      return await response.json();
    }
    if (response.status === 428) {
      return new Promise((resolve) => {
        document.addEventListener(
          "akamai-challenge-noreload",
          async () => {
            resolve(registerLightUser(data));
          },
          { once: true }
        );
      });
    }
    const error = await response.json();
    throw new ApiError("Failed to fetch light-account call", error, response.status);
  };
  try {
    return await postWithAkamaiChallenge("/api/account/light-account", body);
  } catch (err) {
    let validationErrors;
    if (err instanceof ApiError) {
      validationErrors = getValidationErrors(err);
    }
    const error = new RegistrationError(err, {
      validationErrors,
      details: err
    });
    return Promise.reject(error.serialize());
  }
}
const createPassword = async (data) => {
  const { post } = createGlassHttp({
    clientTag: FrontendName
  });
  const { recaptchaSiteKey } = evaluateConfig(accountConfig);
  const body = {
    ...data,
    recaptcha: await getToken(recaptchaSiteKey, {
      action: "create_password"
    })
  };
  try {
    return await post("/api/account/create-password", body);
  } catch (err) {
    return Promise.reject(err);
  }
};
const registrationApi = {
  registerUser,
  registerLightUser,
  createPassword
};
function getValidationErrors(error) {
  if (error.statusCode !== 400 && error.statusCode !== 409) {
    return {};
  }
  const { validationErrors = [] } = error.details;
  return validationErrors.reduce((errors, err) => {
    errors[err.field] = err;
    return errors;
  }, {});
}
export {
  createPassword,
  registrationApi
};
//# sourceMappingURL=registration.js.map
